import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";
import { returnSubmit } from "../../../enums/queryFunction/Submit";
import { SnackbarContext } from "../../../contexts/Snackbar";
import { HttpStatusCode } from "axios";
import logger from "../../../utils/logger";

export default function usePutAppointments(url, key) {
  const { handleSnackbar } = React.useContext(SnackbarContext);
  const [loading, setLoading] = React.useState(false);
  const queryClient = useQueryClient();

  const submitCallback = async (obj) => {
    setLoading(true);
    try {
      const response = await mutateAsync(obj);
      if (response?.status === HttpStatusCode.Ok) {
        setLoading(false);
        return true; 
      }
    } catch (error) {
      logger.error("Mutation failed:", error);
    }
    setLoading(false);
    return false;  
  };
  

  const { mutateAsync } = useMutation({
    mutationFn: (data) => returnSubmit(url, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [key] });
      handleSnackbar("successMessage", "success");
      setLoading(false);
    },
    onError: (error) => {
      handleSnackbar("errorMessage", "error");
      setLoading(false);
    },
  });

  return {
    submitCallback,
    loading,
  };
}
